export default __webpack_public_path__ + "static/media/icon_search_back.ba0c41a7.svg";